import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3faa7228"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "required-action"
}
const _hoisted_2 = { class: "text_zone" }
const _hoisted_3 = { class: "target_glyphes_zone" }
const _hoisted_4 = {
  key: 1,
  class: "required-action"
}
const _hoisted_5 = { class: "opponent_text_zone" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "L'adversaire applique", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = { style: {"margin-top":"10px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TargetGlyphe = _resolveComponent("TargetGlyphe")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.player_action)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.required_actions.me?.text), 1),
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.current_selection, (value) => {
              return (_openBlock(), _createBlock(_component_TargetGlyphe, {
                key: 'target_glyphe_' + value,
                class: "target_glyphe",
                value: value
              }, null, 8, ["value"]))
            }), 128)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.empty_slots, (i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: i,
                class: "target_glyphe"
              }))
            }), 128))
          ]),
          _createElementVNode("div", {
            class: "valid_action_btn",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.validateAction && _ctx.validateAction(...args)))
          }, "VALIDER")
        ]))
      : _createCommentVNode("", true),
    (_ctx.opponent_action)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _hoisted_7,
            _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.required_actions.opponent?.text), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}